import React, { FC, useState } from 'react';
import { DetailSubContainerStyled } from '~/detail/styled';
import { Button, useSideSheetState, ButtonAppearance, Box, Text, ButtonSize, Icon } from '@bechtel/gds';
import { AddCostCode } from '~/detail/cost-code/add-cost-code';
import { Trans, t } from '@lingui/macro';
import { TimesheetCostCodeActionsProps, TimesheetTab, TimesheetTabType } from './types';
import { BoxStyled, TabButtonStyled } from './styled';
import { isUndefined, map } from 'lodash';
import { useLingui } from '@lingui/react';
import { useTimesheet } from '~/detail/context';

const timesheetTabList: TimesheetTab[] = [
  { label: t`Work Packages`, value: TimesheetTabType.WORK_PACKAGES },
  { label: t`Cost Codes`, value: TimesheetTabType.COST_CODES },
];

export const TimesheetCostCodeActions: FC<TimesheetCostCodeActionsProps> = ({
  foreman,
  crewId,
  onCostCodeAdded,
  collapseAll,
  setCollapseAll,
  tsCostCodes,
}) => {
  const { visible: sidesheetVisible, open: openSidesheet, close: closeSidesheet } = useSideSheetState(false);
  const [selectedTab, setSelectedTab] = useState<TimesheetTabType>(timesheetTabList[1].value);
  const { i18n } = useLingui();
  const { isEditable } = useTimesheet();

  return (
    <DetailSubContainerStyled
      style={{ display: 'flex', justifyContent: 'space-between' }}
      data-testid="timesheet-costcode-action-container"
    >
      <Box justifyContent={{ sm: 'space-between' }} alignItems={{ sm: 'center' }} flexGrow={{ sm: '1' }}>
        <Box>
          {map(timesheetTabList, (tabItem: TimesheetTab) => {
            return (
              <TabButtonStyled
                selected={tabItem.value === selectedTab}
                onClick={() => {
                  setSelectedTab(tabItem.value);
                }}
                key={tabItem.value}
                disabled={tabItem.value === TimesheetTabType.WORK_PACKAGES}
              >
                {i18n._(tabItem.label)}
              </TabButtonStyled>
            );
          })}
        </Box>

        <Box alignItems={{ sm: 'center' }} pr={{ sm: '400' }}>
          <Box alignItems={{ sm: 'center' }} mr={{ sm: '600' }}>
            <BoxStyled type="unplanned"></BoxStyled>
            <Text size="300" color="grey.600">
              <Trans>Unplanned</Trans>
            </Text>
          </Box>
          <Box alignItems={{ sm: 'center' }} mr={{ sm: '600' }}>
            <BoxStyled type="planned"></BoxStyled>
            <Text size="300" color="grey.600">
              <Trans>Planned</Trans>
            </Text>
          </Box>
          <Box alignItems={{ sm: 'center' }} mr={{ sm: '600' }}>
            <BoxStyled type="claimed"></BoxStyled>
            <Text size="300" color="grey.600">
              <Trans>Claimed</Trans>
            </Text>
          </Box>
          <Button
            onClick={openSidesheet}
            appearance={ButtonAppearance.SECONDARY}
            size={ButtonSize.SMALL}
            style={{ width: 'auto' }}
            disabled={!isEditable}
            data-testid="add-cost-code-action"
          >
            <Box mr={{ sm: '300' }}>
              <Icon icon="clipboard-list" fillColor="blue.800" iconStyle="duo" />
            </Box>
            <Text size="300" color="grey.1000">
              <Trans>Add New Cost Code</Trans>
            </Text>
          </Button>
          <Box ml={{ sm: '400' }}>
            <Button
              onClick={() => setCollapseAll()}
              appearance={ButtonAppearance.SECONDARY}
              size={ButtonSize.SMALL}
              style={{ width: 'auto', minWidth: '100px' }}
              disabled={isUndefined(tsCostCodes) || tsCostCodes?.length === 0}
            >
              <Box mr={{ sm: '300' }}>
                <Icon icon="compress-arrows-alt" fillColor="blue.800" />
              </Box>
              <Text size="300" color="grey.1000">
                {collapseAll ? <Trans>Expand All</Trans> : <Trans>Collapse All</Trans>}
              </Text>
            </Button>
          </Box>
        </Box>
      </Box>
      {sidesheetVisible && (
        <AddCostCode
          closeSidesheet={closeSidesheet}
          crewId={crewId}
          addCostCode={onCostCodeAdded}
          foreman={foreman}
          tsCostCodes={tsCostCodes}
        />
      )}
    </DetailSubContainerStyled>
  );
};
